import React from 'react';
import { translate } from 'helpers/translateHelper';
import PropTypes from 'prop-types';
import { IconPowertrain } from 'svgIcons/MotionPortalIcons';
import { PowertrainDetails } from '../PowertrainDetails';
import HierarchyAssetSelection from './HierarchyAssetSelection';
import { NODE_TYPE } from './constants';

export default function HierarchyRightPanel(props) {
    const {
        selectedPowertrain,
        searchboxFilter,
        selectedSites,
        sites,
        organizations,
        deletePowertrainRequest,
        convertToLocationRequest,
        setSelectedPowertrain,
        setPowertrainWizardVisible,
        setPowertrainForEditing,
        setWizardSelectedNode,
        selectedIds,
        nodeMap,
        updateHierarchyDataRequest,
        hierarchySelectedAssets,
        setHierarchySelectedAssets,
        hierarchyData,
        getHierarchyDataRequest,
        setHierarchyErrorModal,
        setSaveFailed,
        conversionResult,
        clearConversionResult
    } = props;

    const selectedAsset = selectedIds?.[0] &&
        nodeMap[selectedIds[0]]?.data?.type === NODE_TYPE.UNASSIGNED_ASSETS ? nodeMap[selectedIds[0]]?.data : null;

    const isNotInHierarchy = selectedIds?.[0] &&
        nodeMap[selectedIds[0]]?.data?.type === NODE_TYPE.UNASSIGNED_POWERTRAIN;

    const renderNoPowertrainSelected = () => {
        return (
            <div className='no-powertrain-selected'>
                <IconPowertrain
                    width={48}
                    height={48}
                />
                <div className='content'>
                    <span className='heading'>{translate('ABB.Powertrain.Frontend.noPowertrainSelected')}</span>
                    <span className='detail'>{translate('ABB.Powertrain.Frontend.selectPowertrainToViewDetails')}</span>
                </div>
            </div>
        );
    };

    if (selectedPowertrain) {
        return (
            <PowertrainDetails
                searchboxFilter={searchboxFilter}
                powertrain={selectedPowertrain}
                selectedSites={selectedSites}
                sites={sites}
                organizations={organizations}
                deletePowertrain={deletePowertrainRequest}
                convertToLocationRequest={convertToLocationRequest}
                setSelectedPowertrain={setSelectedPowertrain}
                setPowertrainWizardVisible={setPowertrainWizardVisible}
                setPowertrainForEditing={setPowertrainForEditing}
                isNotInHierarchy={!!isNotInHierarchy}
            />
        );
    }

    if (selectedAsset) {
        return <HierarchyAssetSelection
            selectedAsset={selectedAsset}
            setPowertrainWizardVisible={setPowertrainWizardVisible}
            setWizardSelectedNode={setWizardSelectedNode}
            selectedIds={selectedIds}
            nodeMap={nodeMap}
            updateHierarchyDataRequest={updateHierarchyDataRequest}
            organizations={organizations}
            hierarchySelectedAssets={hierarchySelectedAssets}
            setHierarchySelectedAssets={setHierarchySelectedAssets}
            hierarchyData={hierarchyData}
            getHierarchyDataRequest={getHierarchyDataRequest}
            setHierarchyErrorModal={setHierarchyErrorModal}
            setSaveFailed={setSaveFailed}
            conversionResult={conversionResult}
            clearConversionResult={clearConversionResult}
            selectedSites={selectedSites}
        />;
    }

    return (
        <div className='right-panel-content empty-state'>
            {renderNoPowertrainSelected()}
        </div>
    );
}

HierarchyRightPanel.propTypes = {
    selectedPowertrain: PropTypes.object,
    searchboxFilter: PropTypes.string,
    selectedSites: PropTypes.array,
    sites: PropTypes.array,
    organizations: PropTypes.array,
    deletePowertrainRequest: PropTypes.func,
    convertToLocationRequest: PropTypes.func,
    setSelectedPowertrain: PropTypes.func,
    setPowertrainWizardVisible: PropTypes.func,
    setPowertrainForEditing: PropTypes.func,
    setWizardSelectedNode: PropTypes.func,
    selectedAsset: PropTypes.object,
    hierarchyData: PropTypes.array,
    updateHierarchyDataRequest: PropTypes.func,
    hierarchySelectedAssets: PropTypes.array,
    setHierarchySelectedAssets: PropTypes.func,
    selectedIds: PropTypes.array,
    nodeMap: PropTypes.object,
    getHierarchyDataRequest: PropTypes.func,
    setHierarchyErrorModal: PropTypes.func,
    setSaveFailed: PropTypes.func,
    conversionResult: PropTypes.object,
    clearConversionResult: PropTypes.func,
};
